/* src/app/pages/shop/ticket/ticket.page.scss */
ticket {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-right: 120px;
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
}
ticket .ticket-actions {
  position: absolute;
  top: 20px;
  left: 20px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
ticket .ticket-actions .print,
ticket .ticket-actions .close {
  font-size: 34px;
  padding: 24px;
}
ticket .ticket-actions .print ion-icon,
ticket .ticket-actions .close ion-icon {
  color: #fff !important;
}
/*# sourceMappingURL=ticket.page.css.map */
